import angular from 'angular';
import CategoriesInputFilter from './categories-input-filter.component';

let CategoriesFilterModule = angular.module('catalog.categoriesFilter.categoriesInputFilter', [])
  .component('categoriesInputFilter', CategoriesInputFilter);

export default CategoriesFilterModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-input-filter/categories-input-filter.js
 **/